import angular from "angular";

angular
	.module('app')
	.component('notificationTaskAccepted', {
		template: require('./notification-task-accepted.html'),
        controller: ['$http', controller],
        bindings: {
			resolve: '<',
			close: '&',
			dismiss: '&'
        }
    });

function controller($http) {

	let $ctrl = this;

	$ctrl.$onInit = function () {
		$ctrl.notify = $ctrl.resolve.notification;
	};
}